import { DocBreadcrumbType } from 'routes/Docs/components/DocsBreadcrumbs'
import { DocArticleType } from 'routes/Docs/types'

import { getArticle } from './get-article'

export function getArticleBreadcrumbs(path: string): DocBreadcrumbType[] {
  const article = getArticle(path)

  if (!article) {
    return []
  }

  return [...getNodeParents(article).reverse(), article].map((article) => ({
    path: getArticle(article.path)?.Component ? article?.path : undefined,
    title: article?.title,
  }))
}

function getNodeParents(article: DocArticleType): DocArticleType[] {
  const parents = []
  let articleParent = article?.parent

  while (articleParent) {
    // FIXME: strictNullCheck temporary fix
    // @ts-expect-error TS(2345): Argument of type 'DocArticleType' is not assignabl... Remove this comment to see the full error message
    parents.push(articleParent)
    articleParent = articleParent?.parent
  }

  return parents
}
